<template>
  <box tag="section" class="p-0" v-if="information.length">
    <h3>{{ $t('companyInformation') }}</h3>
    <ul class="list-unstyled m-0">
      <sidebar-list-item v-for="item in information" :key="item.field">
        <a
          v-if="isLink(item.uri)"
          :href="`http://${item.uri}`"
          class="d-flex align-items-center link"
          :title="item.title || item.uri"
          target="_blank"
        >
          <svg-icon
            :icon="item.icon.name"
            fallback-icon="link"
            :class="item.icon.color || 'text-lighten'"
          />
          <span v-if="item.title"> {{ item.title | capitalize }} </span>
          <span v-else>{{ item.uri }}</span>
          <svg-icon icon="chevron-right" />
        </a>
        <div v-else class="d-flex align-items-center link">
          <svg-icon
            :icon="item.icon.name"
            fallback-icon="link"
            :class="item.icon.color || 'text-lighten'"
          />
          <span v-if="item.title"> {{ item.title | capitalize }} </span>
        </div>
      </sidebar-list-item>
    </ul>
  </box>
</template>

<script>
import SidebarListItem from './SidebarListItem.vue';
import isLink from '@/utils/isLink.js';

export default {
  components: {
    SidebarListItem
  },

  props: {
    information: {
      type: Array,
      required: true
    }
  },

  methods: {
    isLink: isLink
  }
};
</script>

<style lang="scss" scoped>
h3 {
  text-transform: uppercase;
  font-size: 12px;
  color: $light;
  padding: 1rem;
  border-bottom: 1px solid $border-color;
  margin-bottom: 0;
}

li {
  border-bottom: 1px solid $border-color;

  &:hover,
  &:focus {
    background: $lighten-bg;

    .icon-chevron-right {
      color: $primary;
    }
  }

  &:active {
    background: $body-bg;
  }

  &:last-child {
    border-bottom: 0;
  }

  .link {
    color: $body-color;
    text-decoration: none;
    padding: 1rem;
  }

  i,
  span {
    vertical-align: middle;
  }

  i {
    margin-right: 0.5rem;
  }
}
.icon {
  width: 20px;
  text-align: center;

  svg {
    height: 1rem;
  }
}

.icon-chevron-right {
  font-size: 0.5rem;
  color: $lighten;
  margin-left: auto;
}
</style>
